module.exports = __webpack_public_path__ + "img/mmi-about-photo-03-mighty-minds-friends.9a6cccd1.png";